import React from "react";

const MicrosoftSvg = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9Z"
        fill="#00A4EF"
      />
      <path
        d="M8.57143 8.57143H4.28571V4.28571H8.57143V8.57143ZM13.7143 8.57143H9.42857V4.28571H13.7143V8.57143ZM8.57143 13.7143H4.28571V9.42857H8.57143V13.7143ZM13.7143 13.7143H9.42857V9.42857H13.7143V13.7143Z"
        fill="white"
      />
    </svg>
  );
};

export default MicrosoftSvg;
